import { server, port } from "./environment";

const URL = `${server}:${port}`;

const clientesComService = {
  async getClientes() {
    try {
      const response = await fetch(`${URL}/api/clientesCom/`);
      if (!response.ok) {
        throw new Error("Error al obtener los clientes");
      }
      return await response.json();
    } catch (error) {
      console.error(error);
      return { error: error.message };
    }
  },

  async importClientes(clientes) {
    try {
      const response = await fetch(`${URL}/api/clientesCom/import`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(clientes),
      });
      if (!response.ok) {
        throw new Error("Error al importar los clientes");
      }
      return await response.json();
    } catch (error) {
      console.error(error);
      return { error: error.message };
    }
  },
};

export default clientesComService;
